<template>
  <div class="ext-app-wrapper">
    <div v-if="showHeader" class="app-header-wrapper">
      <div class="header-left">
        <div class="button" @click="handleLastPageClick"><a-icon type="arrow-left" /></div>
        <div class="button" @click="handleNextPageClick"><a-icon type="arrow-right" /></div>
      </div>
      <div class="header-center">
        {{ $route.meta.title }}
      </div>
      <div class="header-right">
        <div v-if="appData?.systemAdminUrl" class="button" @click="handleAdminClick(appData?.systemAdminUrl)">
          <a-icon type="desktop" /></div>
        <div class="button" @click="handleRefreshClick()"><a-icon type="redo" /></div>
      </div>
    </div>
    <iframe
        :id="code" v-if="appData.pcUrl" :src="urlWithToken" ref="frame">
    </iframe>
  </div>
</template>

<script>
import storage from 'store'
import { TENANT } from '@/store/mutation-types'
import { getAppDetailByCode, targetPlatformSsoApi } from '@/api/admin/app'
import { getSsoTicket } from '@/api/oauth2'
import {mapGetters} from "vuex";

export default {
  name: "IframeLayout",
  props: {
    url: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      require: true
    }
  },
  data(){
    return {
      appData: {},
      urlWithToken: '',
	    showHeader: true
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo','info']),
  },
  mounted() {
    getAppDetailByCode({ appCode: this.code }).then(res => {
      if (res.success) {
        if(res.data){
          this.appData = res.data
	        if (this.url) {
		        this.appData.pcUrl = this.url
	        }
          if (this.appData.pcUrl) {
            const param = {
              appId: this.appData.id,
              redirectUrl: this.appData.pcUrl.replace('#tenant#', storage.get(TENANT))
            }
            if(this.appData.ssoType === 1){
              getSsoTicket(param).then(res => {
                if (res.success) {
                  this.urlWithToken = res.data;
                }
              });
            }else{
              targetPlatformSsoApi({ url: this.appData.pcUrl }).then(res => {
                console.log(res)
                this.urlWithToken = res.data
              })
            }
          }
        }
      }
    })
  },
  methods: {
    postMessageToIframe(action) {
      const iframe = this.$refs.frame;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(action, '*');
      }
    },
    handleLastPageClick() {
      this.postMessageToIframe('goBack');
    },
    handleNextPageClick() {
      this.postMessageToIframe('goForward');
    },
    handleRefreshClick() {
      this.postMessageToIframe('refresh');
    },
    handleAdminClick(adminUrl) {
      if(adminUrl){
        window.open(adminUrl.replace('#tenant#', storage.get(TENANT)))
      }
    },
	  openApp(data) {
		  getAppDetailByCode({ appCode: data.appCode }).then(res => {
				if (res.success) {
					const url = new URL(res.data.pcUrl)
					const path = url.protocol + '//' + url.hostname + ':' + url.port + data.path
					console.log('path', path)
					const appData = {
						name: res.data.name,
						code: res.data.code,
						icon: res.data.icon,
						url: path
					}

					this.routes = this.$router.getRoutes()
					console.log('this.$route', this.$route)
					const currentCode = this.routes.filter(item => item.name === appData.code)
					if (currentCode.length > 0) {
						this.$store.dispatch('DeleteTab', this.$route.name)
						this.$store.dispatch('DeleteTab', appData.code)
						this.$store.dispatch('AddTab', appData).then(() => {
							this.$router.push({ name: appData.code })
						})
					} else {
						this.$message.warn('当前暂无此应用，请联系管理员！')
					}
				}
		  })

	  },
  },
	created() {
		window.addEventListener('message', (event) => {
			// 处理接收到的消息
			switch (event.data.type) {
				case 'hideHeader':
					this.showHeader = false
					break;
				case 'showHeader':
					this.showHeader = true
					break;
				case 'openApp':
					console.log('openApp', event)
					this.openApp(event.data.data)
					break;
				default:
					break;
			}
		})
	}
}
</script>

<style lang="less" scoped>
.ext-app-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .app-header-wrapper {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #E5E6E8;

    .header-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 150px;
      margin-left: 15px;

      .button {
        margin-right: 15px;
        cursor: pointer;
        font-size: 16px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        justify-content: center;
        &:hover {
          background: rgb(233,234,235);
        }
      }
    }

    .header-center {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    .header-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 150px;
      margin-right: 15px;

      .button {
        margin-left: 15px;
        cursor: pointer;
        font-size: 18px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        &:hover {
          background: rgb(233,234,235);
        }
      }
    }
  }
  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
  }
}
</style>
